__turbopack_context__.v({
  "activeFilters": "styles-module-scss-module__1OiTUW__activeFilters",
  "filterContainer": "styles-module-scss-module__1OiTUW__filterContainer",
  "filters": "styles-module-scss-module__1OiTUW__filters",
  "filtersContainer": "styles-module-scss-module__1OiTUW__filtersContainer",
  "filtersLogo": "styles-module-scss-module__1OiTUW__filtersLogo",
  "title": "styles-module-scss-module__1OiTUW__title",
  "titleContainer": "styles-module-scss-module__1OiTUW__titleContainer",
});
